(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monakler-short-macarena-3x1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('monakler-short-landing')) {
    customElements.define('monakler-short-landing', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.smReady === 'true') return;
        this.dataset.smReady = 'true';
        this.classList.add('sm-motion');
        this.liveRegion = this.querySelector('[data-sm-live]');
        this.sticky = this.querySelector('[data-sm-sticky]');
        this.stickyButton = this.sticky?.querySelector('[data-sm-buy]');
        this.customAnchor = this.dataset.buyAnchor?.trim();
        this.updateStickyBound = this.updateSticky.bind(this);

        this.querySelectorAll('[data-sm-buy]').forEach((button) => {
          button.addEventListener('click', () => this.goToBuy());
        });

        this.collectDescriptionImages();
        this.activateReveal();
        window.addEventListener('scroll', this.updateStickyBound, { passive: true });
        window.addEventListener('resize', this.updateStickyBound, { passive: true });
        this.updateSticky();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateStickyBound);
        window.removeEventListener('resize', this.updateStickyBound);
        this.revealObserver?.disconnect();
      }

      buyTarget() {
        if (this.customAnchor) {
          try {
            const customTarget = document.querySelector(this.customAnchor);
            if (customTarget) return customTarget;
          } catch (error) {}
        }

        const selectors = ['.kaching-bundles__block', '[data-kaching-bundles]', 'product-form', '.product-form', '[id^="ProductInfo-"]'];
        for (const selector of selectors) {
          for (const element of document.querySelectorAll(selector)) {
            if (!this.contains(element) && element.getClientRects().length) return element;
          }
        }
        return document.querySelector('[id^="ProductInfo-"]') || document.querySelector('main');
      }

      goToBuy() {
        const target = this.buyTarget();
        if (!target) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        target.classList.add('sm-buy-highlight');
        window.setTimeout(() => target.classList.remove('sm-buy-highlight'), 1500);
        if (this.liveRegion) this.liveRegion.textContent = 'Te llevamos al selector de la promoción 3x1.';
      }

      imageKey(source) {
        if (!source || source.startsWith('data:')) return '';
        try {
          const url = new URL(source, window.location.href);
          return url.pathname
            .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*)(?=\.[a-z0-9]+$)/i, '')
            .toLowerCase();
        } catch (error) {
          return source.split('?')[0].toLowerCase();
        }
      }

      sourceFromImage(image) {
        const sourceSet = image.getAttribute('data-srcset') || image.getAttribute('srcset');
        const sourceFromSet = sourceSet?.split(',').pop()?.trim().split(/\s+/)[0];
        const source = image.getAttribute('data-src') || image.getAttribute('data-original') || sourceFromSet || image.getAttribute('src');
        return source?.replace(/\{width\}|\{width\}x/g, '1200') || '';
      }

      collectDescriptionImages() {
        const template = this.querySelector('template[data-sm-description-source]');
        const section = this.querySelector('[data-sm-source-section]');
        const grid = this.querySelector('[data-sm-source-grid]');
        if (!template || !section || !grid) return;

        const known = new Set();
        this.querySelectorAll('[data-sm-gallery-image], .sm-hero__visual img').forEach((image) => {
          const key = this.imageKey(image.currentSrc || image.src);
          if (key) known.add(key);
        });

        let added = 0;
        template.content.querySelectorAll('img').forEach((sourceImage) => {
          const source = this.sourceFromImage(sourceImage);
          const key = this.imageKey(source);
          if (!source || !key || known.has(key)) return;
          known.add(key);

          const figure = document.createElement('figure');
          figure.className = 'sm-reveal';
          const image = document.createElement('img');
          image.src = source;
          const sourceSet = sourceImage.getAttribute('data-srcset') || sourceImage.getAttribute('srcset');
          if (sourceSet) image.srcset = sourceSet.replace(/\{width\}|\{width\}x/g, '1200');
          image.sizes = '(min-width: 990px) 50vw, 100vw';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.alt = sourceImage.getAttribute('alt') || 'Short de Lino Macarena de Monakler';
          figure.appendChild(image);
          grid.appendChild(figure);
          added += 1;
        });

        if (added > 0) section.hidden = false;
      }

      activateReveal() {
        const elements = this.querySelectorAll('.sm-reveal');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!('IntersectionObserver' in window) || reducedMotion) {
          elements.forEach((element) => element.classList.add('is-visible'));
          return;
        }

        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -25px' });
        elements.forEach((element) => this.revealObserver.observe(element));
      }

      updateSticky() {
        if (!this.sticky) return;
        const target = this.buyTarget();
        let targetVisible = false;
        if (target) {
          const rect = target.getBoundingClientRect();
          targetVisible = rect.bottom > 70 && rect.top < window.innerHeight - 70;
        }
        const show = window.scrollY > 600 && !targetVisible;
        this.sticky.classList.toggle('is-visible', show);
        this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (this.stickyButton) this.stickyButton.tabIndex = show ? 0 : -1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
